export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2j-3e247db29eb4bff48a833aec4aa6266e.webp";